<template>
  <div>
     <div class="text-center" v-if="documentsLoading">
      <v-progress-circular
        :size="100"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <iframe v-if="!documentsLoading" :id="'JotFormIFrame-' + creationDocument.attributes.jotform_id" onload="window.parent.scrollTo(0,0)" allowtransparency="true" allow="geolocation; microphone; camera; fullscreen" :src="'https://form.jotform.com/' + creationDocument.attributes.jotform_id + '?' + creationDocument.attributes.jotform_params"  frameborder="0" style="min-width:100%;max-width:100%;height:539px;border:none;" scrolling="true" > </iframe>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'jotform',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(['creatingDocumentState']),
    ...mapGetters(['creationDocument']),
    ...mapGetters(['documentsLoading'])
  },
  watch: {
    creationDocument: {
      handler: 'initJotform',
      immediate: true,
      deep: true
    },
    documentsLoading: 'initJotform'
  },
  methods: {
    initJotform () {
      if (!this.documentsLoading && this.creationDocument && this.creationDocument.attributes && this.creationDocument.attributes.jotform_id) {
        this.$nextTick(() => {
          window.jotformEmbedHandler(`iframe[id='JotFormIFrame-${this.creationDocument.attributes.jotform_id}']`, 'https://form.jotform.com/')
        })
      }
    }
  },
  mounted () {
    if (this.creationDocument) {
      this.$http.post(`/documents/${this.creatingDocumentState.document_id}/change_subprocess_step`, { data: { step_name: 'BPK_6' } })
        .then(response => {
          console.log(response)
        })
    }
  },
  created () {
    this.$store.dispatch('getCreationDocument', this.creatingDocumentState.document_id)
  }
}
</script>

<style lang="scss">
</style>
